import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StepsFromTheSacred from "./sections/StepsFromTheSacred";
import ReachOutToMunirAhmed from "./sections/ReachOutToMunirAhmed";
import TerminalFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StepsFromTheSacred />
      <ReachOutToMunirAhmed />
      <TerminalFooter />
    </div>;
}